import { router, useLocalSearchParams, useNavigation } from 'expo-router';
import { useEffect, useLayoutEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import GoBackButton from '@/components/buttons/GoBackButton';
import FormWrapper from '@/components/forms/FormWrapper';
import TotalGrantProgramForm from '@/components/forms/TotalGrantProgramForm';
import Title from '@/components/Title';
import { TotalGrantProgramData } from '@/lib/validations/NpoOnboardingSchema';
import { i18n } from '@/utils/i18n';
import { safeJsonParse } from '@/utils/jsonParse';

const AddUpdateTotalGrantProgram = () => {
  const navigation = useNavigation<any>();
  const { totalGrantProgamJson, totalGrantProgamIndex } = useLocalSearchParams<{
    totalGrantProgamJson: string;
    totalGrantProgamIndex: string;
  }>();
  const [initialTotalGrantProgram, setInitialTotalGrantProgram] = useState<TotalGrantProgramData | undefined>(
    undefined
  );

  useLayoutEffect(() => {
    navigation.setOptions({
      headerShown: true,
      headerTransparent: true,
      headerTitle: () => <Title label={i18n.t('sign_in.nonProfit.total_grants_programs.add_title')} />,
      headerLeft: () => <GoBackButton navigateTo={'/login/nonProfit/onBoarding/totalGrantsPrograms'} />,
      headerBackVisible: false
    });
  }, [navigation]);

  useEffect(() => {
    if (totalGrantProgamJson) {
      const parsedTotalGrantProgam = safeJsonParse<TotalGrantProgramData>(totalGrantProgamJson);
      if (parsedTotalGrantProgam) setInitialTotalGrantProgram(parsedTotalGrantProgam);
    }
  }, [totalGrantProgamJson]);

  return (
    <SafeAreaView style={styles.content}>
      <FormWrapper keyboardVerticalOffset={0} scrollEnable={false}>
        <View style={styles.container}>
          <TotalGrantProgramForm
            initialData={initialTotalGrantProgram}
            showDoneButton
            onDone={(data) => {
              router.dismissTo({
                pathname: '/(app)/login/nonProfit/onBoarding/totalGrantsPrograms',
                params: {
                  totalGrantProgamJson: JSON.stringify(data),
                  totalGrantProgamIndex: totalGrantProgamIndex
                }
              });
            }}
          />
        </View>
      </FormWrapper>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  content: {
    flex: 1
  },

  container: {
    flex: 1,
    marginTop: 60
  }
});

export default AddUpdateTotalGrantProgram;
